import React from 'react';
import { Container, Typography, Paper, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ReceptionistCreateBookingPage = () => {
  const { t } = useTranslation();
  
  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <Typography variant="h4" gutterBottom>
        {t('receptionist:createBooking.title')}
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Alert severity="info">
          {t('receptionist:createBooking.placeholder')}
        </Alert>
      </Paper>
    </Container>
  );
};

export default ReceptionistCreateBookingPage;

